import React from "react";
import ReactDom from "react-dom";
import GalleryPopup from "./gallery-popup";

export default class GalleryRenderer {
    constructor(container, data, selectedItem, sidebarNodeSelector) {
        this._container = container;
        this._data = data;
        this._selectedItem = selectedItem;
        this._sidebarNodeSelector = sidebarNodeSelector;

        this.onClose = this.onClose.bind(this);
    }

    raiseEvent(name, detail) {
        document.body.dispatchEvent(new CustomEvent(name, { detail: detail }));
    }

    onClose() {
        ReactDom.unmountComponentAtNode(this._container);
        this.raiseEvent("gallery:close", {});
    }

    render() {
        ReactDom.render(<GalleryPopup
            data={this._data}
            selectedItem={this._selectedItem}
            sidebarNodeSelector={this._sidebarNodeSelector}
            onClose={this.onClose} />,
            this._container);
        this.raiseEvent("gallery:open", {});
    }

    set data(value) {
        this._data = value;
        this.render();
    }

    set sidebarNodeSelector(value) {
        this._sidebarNodeSelector = value;
        this.render();
    }

    destroy() {
        ReactDom.unmountComponentAtNode(this._container);
    }
}